import React, { Component, PureComponent } from "react";
import { Metric, Error, selectFormat } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading.js";

const widgetConfig = {
  impressions: {
    label: "Impressions",
  },
  clicks: {
    label: "Clicks",
  },
  video_views_yesterday: {
    label: "Video Views Yesterday",
  },
  views: {
    label: "Views",
  },
  views_25: {
    label: "Views 25",
  },
  views_50: {
    label: "Views 50",
  },
  views_75: {
    label: "Views 75",
  },
  signups: {
    label: "Sign Ups",
  },
  sub_starts: {
    label: "Sub Starts",
  },
  paid_media_cpa: {
    label: "Paid Media CPA",
  },
  sign_ups: {
    label: "Sign Ups",
  },
  landing_page_views: {
    label: "Landing Page Views",
  },
  landing_page_clicks: {
    label: "Landing Page Clicks",
  },
  cost: {
    label: "Cost",
    type: "currency",
  },
  client_cost: {
    label: "Cost",
    type: "currency",
  },
  ctr: {
    label: "CTR",
    type: "percentage",
    format: "%0.00",
  },
  cpm: {
    label: "CPM",
    type: "currency",
    format: "$0.00",
  },
  cpc: {
    label: "CPC",
    type: "currency",
    format: "$0.00",
  },
  cpw: {
    label: "CPW",
    type: "currency",
    format: "$0.00",
  },
  cpa: {
    label: "CPA",
    type: "currency",
    format: "$0.00",
  },
  ecpa: {
    label: "eCPA",
    type: "currency",
    format: "$0.00",
  },
  cpv: {
    label: "CPV",
    type: "currency",
    format: "$0.00",
  },
  cplv: {
    label: "Network CPAs",
    type: "currency",
    format: "$0.00",
  },
  cpcv: {
    label: "CPCV",
    type: "currency",
    format: "$0.00",
  },
  cpvv: {
    label: "CPVV",
    type: "currency",
  },
  network_cpa: {
    label: "Paid Media CPA",
    type: "currency",
    format: "$0.00",
  },
  new_customer_starts: {
    label: "New Customer Starts",
  },
  rentals: {
    label: "Rentals",
  },
  purchases: {
    label: "Purchases",
  },
  free_trial_starts: {
    label: "Free Trial Starts",
  },
  new_starts: {
    label: "New Starts",
  },
  total_free_trial_starts: {
    label: "Total Free Trial Starts",
  },
  fts_from_paid_media: {
    label: "FTS From Paid Media",
  },
  acquisition_spend: {
    label: "Acquisition Spend",
  },

  winbacks: {
    label: "Winbacks",
  },
  new_users: {
    label: "New Users",
  },
  sessions: {
    label: "Sessions",
  },
  session_duration: {
    type: "summsec",
    label: "Session Duration",
  },
  avg_session_time: {
    type: "minsec",
    label: "Avg Session Time",
  },
  avg_time_spent_per_user: {
    type: "minsec",
    label: "Avg Time Spent Per User",
  },
  page_views: {
    label: "Page View",
  },
  total_spend: {
    label: "Total Spend",
    type: "currency",
  },
  purchases_percentage: {
    label: "% from Paid",
    type: "percentage",
  },
  cpsub: {
    type: "currency",
    label: "Est. Paying CPSub",
  },
  paid_media_cpsub: {
    type: "currency",
    label: "Est. Paid Media Paying CPSub",
  },

  first_streams: {
    label: "First Streams",
  },
  first_streams_perc: {
    label: "Total Streams %",
    type: "percentage",
  },
  view_time: {
    label: "View Time",
  },
  view_time_perc: {
    label: "View Time %",
    type: "percentage",
  },
  views_unique: {
    label: "Views Unique",
  },
  views_unique_perc: {
    label: "Views Unique %",
    type: "percentage",
  },
  minutes_watched_yesterday: {
    label: "Minutes Watched Yesterday",
  },
  unique_views_yesterday: {
    label: "Unique Viewers Yesterday",
  },
  total_subs: {
    label: "Total Subs",
  },
  total_winbacks: {
    label: "Total Winbacks",
  },
  monthly_winbacks: {
    label: "Monthly Winbacks",
  },
  annual_winbacks: {
    label: "Annual Winbacks",
  },
  total_new_starts: {
    label: "Total New Starts",
  },
  monthly_new_starts: {
    label: "Monthly New Starts",
  },
  annual_new_starts: {
    label: "Annual New Starts",
  },
  dtc_launch_registrations: {
    label: "DTC Launch Registrations",
  },
  promo_pricing_registrations: {
    label: "Registrations Since Promo Pricing",
  },
  ytd_registrations: {
    label: "Registrations YTD",
  },

  count_of_subscribers: {
    label: "Subscribers Count",
  },
  subscribers_active_pct: {
    label: "% Subscribers Active (GA4) Yesterday",
    type: "percentage",
  },
  days_subscriber_visited_on_avg: {
    label: "Subscriber Visited Days on Avg",
  },
  subscribers_with_renewal: {
    label: "Total Subscribers with Renewal < 30 Days",
  },
  subscribers_up_for_renewal_and_active_last_30d: {
    label: "Subscribers up for Renewal and Active",
    type: "percentage",
    // format: "%",
  },
  avg_session_per_subscriber: {
    label: "Avg. Sessions per Subscriber (Last 30D)",
    type: "number",
    format: "0.00",
  },
  subscriber_user_engagement_time: {
    label: "Yesterday Subscriber Engagement Time",
    type: "minsec",
  },
  active_dtc_conversions: {
    label: "Active Subscriptions",
    type: "percentage",
  },
  active_cancelled_dtc_conversions: {
    label: "Pending Churn",
    type: "percentage",
  },
  churned_dtc_conversions: {
    label: "Churned",
    type: "percentage",
  },
  subscription_starts_active: {
    label: "Active",
    type: "number",
  },
  subscription_starts_churned: {
    label: "Churned",
    type: "number",
  },
  churn_count_less_than_6_months: {
    label: "Churned < 6 Months",
    type: "number",
  },
  churn_count_6_months_to_1_year: {
    label: "Churned 6-12 Months",
    type: "number",
  },
  churn_count_btwn_1_and_2_years: {
    label: "Churned 1-2 Years",
    type: "number",
  },
  churn_count_over_2_years: {
    label: "Churned > 2 Years",
    type: "number",
  },
};

class RenderMetric extends PureComponent {
  render() {
    const { data, type, label, format, size } = this.props;
    const columnClass =
      size === "lg" ? "col-6 col-lg-3 mb-4" : "col-4 col-lg-2 mb-4";

    return (
      <div className={columnClass}>
        <Heading size={6} className={"mb-2"}>
          {label}
        </Heading>
        <Metric {...data} size={size} type={type} format={format} />
      </div>
    );
  }
}

class AdsCoreMetrics extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderMetrics = (data, cells) =>
    cells.map((metric, key) => {
      const metric_data = data[metric];

      const label = widgetConfig[metric].label;
      const type = widgetConfig[metric].type
        ? widgetConfig[metric].type
        : "number";
      const format = widgetConfig[metric].format;
      const size = key < 4 ? "lg" : "md";

      return (
        <RenderMetric
          data={metric_data}
          type={type}
          label={label}
          format={format}
          size={size}
          key={key}
        />
      );
    });

  getExportData = () => {
    const { data, cells } = this.props;
    return {
      data: cells.map((metric) => ({
        Metric: widgetConfig[metric].label,
        Value: selectFormat(
          widgetConfig[metric].type,
          data.data[metric].value,
          widgetConfig[metric].format
        ),
      })),
      opts: {
        type: "other",
      },
    };
  };

  render() {
    const { data, cells } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    Object.keys(widgetConfig).forEach((key) => {
      if (this.props.url.includes("hayu/acquisition-kpis")) {
        switch (key) {
          case "total_spend":
            widgetConfig[key].label = "Total Spend";
            widgetConfig[key].type = "currency";
            break;
          case "new_starts":
            widgetConfig[key].label = "Total New Starts";
            break;
          case "cpa":
            widgetConfig[key].label = "Overall CPA";
            widgetConfig[key].type = "currency";
            widgetConfig[key].format = "$0.00";
            break;
          default:
            break;
        }
      }
    });

    Object.keys(widgetConfig).forEach((key) => {
      if (
        this.props.url.includes("yes-network/acquisition-kpis") ||
        this.props.url.includes("gotham/acquisition-kpis")
      ) {
        switch (key) {
          case "new_starts":
            widgetConfig[key].label = "Subscriptions Starts (Evergent)";
            break;
          case "sub_starts":
            widgetConfig[key].label = "Subscription Starts (Ad Networks)";
            break;
          case "cpa":
            widgetConfig[key].label = "Overall CPA";
            widgetConfig[key].type = "currency";
            widgetConfig[key].format = "$0.00";
            break;
          case "paid_media_cpa":
            widgetConfig[key].label = "Paid Media CPA";
            widgetConfig[key].type = "currency";
            widgetConfig[key].format = "$0.00";
            break;
          default:
            break;
        }
      }
    });

    return (
      <div className="row mb-3 mb-md-0 mt-4 mt-md-0">
        {this.renderMetrics(data.data, cells)}
      </div>
    );
  }
}

export default AdsCoreMetrics;
